import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import DropDownInput from "../DropDownInput/DropDownInput";
import Input from "../Input/Input";
import { FaTrash } from "react-icons/fa6";
import websiteIcon from "../../assets/icons/website.svg";
import Icon from "../Icon/Icon";
import { ErrorMessage } from "../Input/InputError";
import {
  getSocialOptionById,
  isValidSocialHandle,
  socialOptions,
} from "../../util/socials";
import { getSocialOption } from "../../util/styleUtils";
import { IoCloseOutline } from "react-icons/io5";
import IconButton from "../kit/IconButton";

export const SocialLinkOption = ({ label, iconClassName, Icon }) => {
  return (
    <div className="flex justify-start items-center">
      <div>
        <Icon
          className={`inline-block mr-kit-12 translate-y-[-10%] ${iconClassName}`}
          color="var(--inyc-primary-text-color-light)"
          size={18}
        />
      </div>
      <div className="text-kit-md leading-[1rem]">{label}</div>
    </div>
  );
};

const options = socialOptions.map((opt) => {
  return {
    ...opt,
    label: <SocialLinkOption label={opt.id} Icon={opt.rawIcon} />,
  };
});

//add a custom option
options.push({
  id: "custom",
  label: (
    <SocialLinkOption
      label="custom"
      Icon={options?.find((opt) => opt.id === "website")?.rawIcon}
    />
  ),
});

// const SocialsInput = forwardRef(
//   (
//     {
//       linkError,
//       platformError,
//       value,
//       onChange,
//       z,
//       onDelete,
//       onAddSocial,
//       opts = [],
//     },
//     ref
//   ) => {
//     const [selectedSocial, setSelectedSocial] = useState(value?.platform || "");
//     // value?.platform !== undefined ? value.platform : options[0].id
//     const [socialLink, setSocialLink] = useState(value?.link || "");
//     const dropdownRef = useRef();
//     const linkRef = useRef();
//     const platformRef = useRef();

//     useImperativeHandle(ref, () => ({
//       getWrapperRef: () => dropdownRef.current.getWrapperRef(),
//       focusLinkInput: () => linkRef.current.focus(),
//       focusPlatformInput: () => platformRef.current.focus(),
//       linkInput: () => linkRef.current,
//       platformInput: () => platformRef.current,
//     }));

//     // useEffect(() => {
//     //   console.log(dropdownRef.current);
//     // }, [dropdownRef]);

//     useEffect(() => {
//       if (value) {
//         setSelectedSocial(value?.platform || "");
//         setSocialLink(value?.link || "");
//       }
//     }, [value]);
    

//     // useEffect(() => {
//     //   // alert(`value ${JSON.stringify(value,null,2)}`);
//     //   if (value) {
//     //     if (value.platform !== undefined) {
//     //       setSelectedSocial(value.platform);
//     //     }

//     //     setSocialLink(value.link || "");
//     //   }
//     // }, [value]);

//     useEffect(() => {
//       if (value?.platform !== selectedSocial || value?.link !== socialLink) {
//         onChange && onChange({ platform: selectedSocial, link: socialLink });
//       }
//     }, [selectedSocial, socialLink]);

//     const dropdownWrapperRef = dropdownRef?.current?.getWrapperRef();
//     const selectedOption = getSocialOption(socialLink);
//     const placeholder = selectedOption?.placeholder || "display name";
//     return (
//       <div className="relative [&:hover>.close-btn]:pointer-events-auto [&:hover>.close-btn]:opacity-[1]">
//         <div className="">
//           <Input
//             Ref={linkRef}
//             value={socialLink}
//             onChange={(e) => {
//               console.log('onchange ',e.target.value);
//               const selectedOp = getSocialOption(e.target.value);
//               if (selectedOp?.extract) {
//                 setSelectedSocial(selectedOp.extract(e.target.value));
//               }
//               setSocialLink(e.target.value);
//               // if extract is applicable then extract the username
//             }}
//             placeHolder="link"
//             icon={
//               getSocialOption(socialLink).icon || (
//                 <Icon
//                   className="!w-[25px] invert-[var(--inyc-lighten-white)]"
//                   src={websiteIcon}
//                 />
//               )
//             }
//             InlineComp={() => (
//               <div className="flex h-full gap-kit-20 items-center justify-end">
//                 <div className="w-[1.5rem] h-[1.5rem] flex items-center justify-center">
//                   <FaCirclePlus
//                     size={17}
//                     color="var(--inyc-primary-text-color-light)"
//                     className="cursor-pointer duration-300"
//                     onClick={onAddSocial}
//                   />
//                 </div>
//                 <div
//                   className="w-[1.6rem] h-[1.6rem] flex items-center justify-center"
//                   onClick={onDelete}
//                 >
//                   <IoCloseOutline
//                     size={18}
//                     color="var(--inyc-primary-text-color-light)"
//                     className="cursor-pointer duration-300"
//                   />
//                 </div>
//               </div>
//             )}
//           />
//           {linkError && <ErrorMessage>{linkError}</ErrorMessage>}
//         </div>
//         <div
//           className="mb-[-1rem] mt-kit-4 px-kit-16 text-kit-sm"
//         >
//           paste the url above
//         </div>
//         <Input
//           Ref={platformRef}
//           value={selectedSocial}
//           onChange={(e) => {
//             setSelectedSocial(e.target.value);
//             const url = selectedOption?.validateAndCompleteLink ? selectedOption?.validateAndCompleteLink(
//               socialLink,
//               e.target.value
//             ) : socialLink;
//             // console.log('url ' , url);
//             setSocialLink(url);
//           }}
//           placeHolder={placeholder}
//         />
//         {platformError && <ErrorMessage>{platformError}</ErrorMessage>}
//       </div>
//     );
//   }
// );

// export default SocialsInput;
const SocialsInput = forwardRef(
  (
    {
      linkError,
      platformError,
      value = { platform: "", link: "" },
      onChange,
      z,
      onDelete,
      opts = [],
    },
    ref
  ) => {
    const dropdownRef = useRef();
    const linkRef = useRef();
    const platformRef = useRef();
    const [linkValidationError, setLinkValidationError] = useState("");

    useImperativeHandle(ref, () => ({
      getWrapperRef: () => dropdownRef.current?.getWrapperRef?.(),
      focusLinkInput: () => linkRef.current?.focus(),
      focusPlatformInput: () => platformRef.current?.focus(),
      linkInput: () => linkRef.current,
      platformInput: () => platformRef.current,
    }));

    const getKnownSocialId = (platform) => {
      return socialOptions.some((option) => option.id === platform) ? platform : null;
    };

    const isBareHandle = (link = "") => {
      const trimmed = String(link).trim();
      return /^@+[a-zA-Z0-9._]*$/.test(trimmed);
    };

    const isUrlLike = (link = "") => {
      if (isBareHandle(link)) return false;
      return /^https?:\/\//i.test(link) ||
        link.includes(".") ||
        link.includes("/");
    };

    const getSelectedSocialId = () => {
      return value.socialType || getKnownSocialId(value.platform) || null;
    };

    const getActiveSocialId = (link = value.link) => {
      const selectedId = getSelectedSocialId();

      if (isUrlLike(link) && link) {
        const detectedId = getSocialOption(link)?.id;
        if (detectedId && detectedId !== "website") {
          return detectedId;
        }
      }

      return selectedId || (link ? getSocialOption(link)?.id : null);
    };

    const getUrlWithProtocol = (link) => {
      return /^https?:\/\//i.test(link) ? link : `https://${link}`;
    };

    const isValidUrl = (link) => {
      try {
        const url = new URL(getUrlWithProtocol(link));
        return Boolean(url.hostname && url.hostname.includes("."));
      } catch {
        return false;
      }
    };

    const getContextForSocialId = (socialId) => {
      const option = getSocialOptionById(socialId);
      const linkPlaceholder =
        option?.patterns?.[0] ||
        (socialId === "website" ? "www.example.com/" : value.linkPlaceholder);

      return {
        ...(socialId ? { socialType: socialId } : {}),
        ...(linkPlaceholder ? { linkPlaceholder } : {}),
      };
    };

    const normalizeCommittedLink = (rawLink) => {
      const trimmedLink = rawLink.trim();
      const selectedSocialId = getSelectedSocialId();
      if (!trimmedLink) {
        return { link: "", error: "", socialId: selectedSocialId };
      }

      const handle = trimmedLink.replace(/^@+/, "").trim();
      const looksLikeUrl = isUrlLike(trimmedLink);
      const selectedOption = getSocialOptionById(selectedSocialId);
      const canCompleteHandle =
        selectedOption?.buildProfileUrl && isValidSocialHandle(handle);

      if (trimmedLink.startsWith("@") && canCompleteHandle) {
        return {
          link: selectedOption.buildProfileUrl(handle),
          error: "",
          socialId: selectedSocialId,
        };
      }

      if (!looksLikeUrl && canCompleteHandle) {
        return {
          link: selectedOption.buildProfileUrl(handle),
          error: "",
          socialId: selectedSocialId,
        };
      }

      if (isValidUrl(trimmedLink)) {
        const link = getUrlWithProtocol(trimmedLink);
        return {
          link,
          error: "",
          socialId: getSocialOption(link)?.id || "website",
        };
      }

      return {
        link: rawLink,
        error: "must be a url link",
        socialId: selectedSocialId,
      };
    };

    const emitLinkChange = (link, socialId) => {
      onChange({
        ...getContextForSocialId(socialId || getActiveSocialId(link)),
        platform: value.platform,
        link,
      });
    };

    const handleLinkChange = (e) => {
      const newLink = e.target.value;
      setLinkValidationError("");
      emitLinkChange(newLink, getActiveSocialId(newLink));
    };

    const commitLinkValue = (rawLink) => {
      const { link, error, socialId } = normalizeCommittedLink(rawLink);
      setLinkValidationError(error);
      emitLinkChange(link, socialId);
    };

    const handleLinkBlur = (e) => {
      commitLinkValue(e.target.value);
    };

    const handleLinkKeyDown = (e) => {
      if (e.key !== "Enter") return;
      commitLinkValue(e.target.value);
    };

    const handlePlatformChange = (e) => {
      const newPlatform = e.target.value;
      const selectedOption = getSocialOption(value.link);
      const newLink = selectedOption?.validateAndCompleteLink?.(
        value.link, 
        newPlatform
      ) || value.link;

      onChange({
        ...getContextForSocialId(getActiveSocialId(newLink)),
        platform: newPlatform,
        link: newLink
      });
    };

    const activeSocialId = getActiveSocialId(value.link);
    const selectedOption =
      getSocialOptionById(activeSocialId) ||
      getSocialOptionById(value.socialType) ||
      getSocialOption(value.link || "https://example.com");
    
    const placeholder = selectedOption?.placeholder || "display name";
    const linkPlaceholder =
      selectedOption?.patterns?.[0] ||
      value.linkPlaceholder ||
      (selectedOption?.id === "website" ? "www.example.com/" : "link");

    return (
      <div
        className="relative [&:hover>.close-btn]:pointer-events-auto [&:hover>.close-btn]:opacity-[1]"
        data-social-id={activeSocialId || ""}
      >
        <div>
          <Input
            Ref={linkRef}
            value={value.link}
            onChange={handleLinkChange}
            onBlur={handleLinkBlur}
            placeHolder={linkPlaceholder}
            icon={
              selectedOption?.icon || (
                <Icon
                  className="!w-[25px] invert-[var(--inyc-lighten-white)]"
                  src={websiteIcon}
                />
              )
            }
            InlineComp={() => (
              <div className="flex h-full items-center justify-end">
                <IconButton label="remove link" variant="danger" size="xs" icon={<IoCloseOutline />} onClick={onDelete} />
              </div>
            )}
            onKeyDown={handleLinkKeyDown}
          />
          {(linkValidationError || linkError) && (
            <ErrorMessage
              hideIcon
              className="!pl-kit-20 !text-kit-base !font-['Primary-Bold'] !font-bold"
            >
              {linkValidationError || linkError}
            </ErrorMessage>
          )}
        </div>
        <div className="mt-kit-6">
          <Input
            Ref={platformRef}
            value={value.platform}
            onChange={handlePlatformChange}
            placeHolder={placeholder}
          />
        </div>
        {platformError && <ErrorMessage>{platformError}</ErrorMessage>}
      </div>
    );
  }
);

export default SocialsInput;